import { render, staticRenderFns } from "./ForDevelopers.vue?vue&type=template&id=21299d96&scoped=true&"
import script from "./ForDevelopers.vue?vue&type=script&lang=js&"
export * from "./ForDevelopers.vue?vue&type=script&lang=js&"
import style0 from "./ForDevelopers.vue?vue&type=style&index=0&id=21299d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21299d96",
  null
  
)

export default component.exports